<template>
  <div>
    <section class="account-section padding-bottom padding-top">
      <div class="container">
        <div class="account-wrapper">
          <div class="left-side">
            <div class="section-header">
              <h2 class="title">Cadastre-se</h2>
              <p class="title red" v-if="getAuth && !getRegisterCompleted">
                Você se autenticou pelo <u>{{ getAuth.profile.idp }}</u>, <b> complete seu cadastro</b> abaixo.
              </p>
            </div>
            <!--<ul class="login-with">
              <li>
                <a href="javascript:void(0)" class="facebook"
                  ><i class="fab fa-facebook"></i>Entrar com Facebook</a
                >
              </li>
              <li>
                <a href="javascript:void(0)" class="google"
                  ><i class="fab fa-google-plus"></i>Entrar com Google</a
                >
              </li>
            </ul>
            <div class="or">
              <span>Ou</span>
            </div>-->
            <form class="login-form" @submit.prevent="cadastro">
              <div class="row">
                <div class="col-12">
                  <p class="title"><i class="fas fa-user"></i> Tipo de Pessoa</p>
                  <hr />
                </div>
                <div class="form-group mb-30 col-12 col-md-12">
                  <label for="tipoPessoa"><i class="fas fa-users-cog"></i></label>
                  <select id="tipoPessoa" v-model="tipoPessoa" required>
                    <option value="PF">Pessoa Física</option>
                    <option value="PJ">Pessoa Juridica</option>
                  </select>
                </div>
              </div>

              <div class="row justify-content-center" v-if="tipoPessoa == 'PF'">
                <div class="col-12">
                  <p class="title"><i class="far fa-address-card"></i> Dados Pessoais</p>
                  <hr />
                </div>

                <div class="form-group mb-30 col-12">
                  <label for="nome-completo"><i class="fas fa-user"></i></label>
                  <input type="text" id="nome-completo" placeholder="Nome completo" v-model="nomeCompleto" required />
                </div>

                <div class="form-group mb-30 col-12">
                  <label for="cpf"><i class="fas fa-id-card"></i></label>
                  <input :class="verifyNumeroDocumento" type="text" id="cpf" placeholder="CPF" v-model="numeroDocumento"
                    v-mask="'###.###.###-##'" required @input="debounceCheckNumeroDocumento" />
                </div>

                <div class="d-flex w-100 pl-3">
                  <p v-if="getLoadingNumeroDocumento">
                    <i class="fas fa-spinner fa-spin mr-2"></i>
                    Verificando...
                  </p>
                  <p v-if="numeroDocumento && getNumeroDocumentoExists === true && !getLoadingNumeroDocumento"
                    class="text-danger">
                    <i class="fas fa-times-circle text-danger mr-1"></i>
                    O CPF está sendo utilizado por outro usuário.
                  </p>
                  <p v-if="numeroDocumento && getNumeroDocumentoExists === false && !getLoadingNumeroDocumento"
                    class="text-success">
                    <i class="fa fa-check-circle text-success mr-1"></i>
                    O CPF está disponível.
                  </p>
                </div>

                <div class="form-group mb-30 col-12 col-md-6">
                  <label for="data-nascimento"><i class="fas fa-calendar-alt"></i></label>
                  <input type="text" id="data-nascimento" placeholder="Data nascimento" v-model="dataNascimento"
                    v-mask="'##/##/####'" required />
                </div>

                <div class="form-group mb-30 col-12 col-md-6">
                  <label for="genero"><i class="fas fa-venus-mars"></i></label>
                  <select id="genero" v-model="genero" required>
                    <option value="">Gênero</option>
                    <option value="F">Feminino</option>
                    <option value="M">Masculino</option>
                    <option value="O">Outro</option>
                  </select>
                </div>
                <div class="form-group mb-30 col-12 col-md-6">
                  <label for="telefone"><i class="fas fa-phone-alt"></i></label>
                  <input type="text" id="telefone" placeholder="Celular" v-model="telefone" v-mask="'(##) #####-####'"
                    required />
                </div>
                <div class="form-group mb-30 col-12 col-md-6">
                  <label for="telefone-conf"><i class="fas fa-phone-alt"></i></label>
                  <input type="text" id="telefone-conf" placeholder="Confirmação de Celular" v-model="telefoneconf"
                    v-mask="'(##) #####-####'" required />
                </div>

                <div class="form-group mb-30 col-12 col-md-6">
                  <label for="rg"><i class="fas fa-id-card"></i></label>
                  <input type="text" id="rg" placeholder="RG" v-model="rg" />
                </div>

                <div class="form-group mb-30 col-12 col-md-6">
                  <label for="orgao-emissor"><i class="fas fa-users-cog"></i></label>
                  <input type="text" id="orgao-emissor" placeholder="Orgão Emissor" v-model="orgaoEmissor" />
                </div>

                <!-- <div class="form-group mb-30 col-12 col-md-4">
                  <label for="data-emissao"><i class="fas fa-calendar-alt"></i></label>
                  <input type="text" id="data-emissao" placeholder="Data emissão" v-model="dataEmissor" v-mask="'##/##/####'" required />
                </div>  -->

                <div class="col-12">
                  <p class="title"><i class="fas fa-map-marker-alt"></i> Endereço</p>
                  <hr />
                </div>
                <div class="form-group mb-30 col-12 col-md-4">
                  <label for="form-cep"><i class="fas fa-location-arrow"></i></label>
                  <input type="text" id="form-cep" placeholder="cep" v-model="endereco.cep" required
                    v-mask="'#####-###'" v-on:change="searchCep" />
                  <span class="pass-type" v-if="getLoadingCep"><i class="fa fa-spin fa-spinner"></i></span>
                </div>

                <div class="form-group mb-30 col-12 col-md-8">
                  <label for="form-logradouro"><i class="fas fa-road"></i></label>
                  <input type="text" id="form-logradouro" placeholder="Logradouro" v-model="endereco.logradouro"
                    required />
                </div>
                <div class="form-group mb-30 col-12 col-md-4">
                  <label for="form-numero"><i class="fas fa-map-pin"></i></label>
                  <input type="text" id="form-numero" placeholder="Número" v-model="endereco.numero" required />
                </div>

                <div class="form-group mb-30 col-12 col-md-8">
                  <label for="form-complemento"><i class="fas fa-map-signs"></i></label>
                  <input type="text" id="form-complemento" placeholder="Complemento" v-model="endereco.complemento" />
                </div>

                <div class="form-group mb-30 col-12 col-md-4">
                  <label for="form-bairro"><i class="fas fa-building"></i></label>
                  <input type="text" id="form-bairro" placeholder="Bairro" v-model="endereco.bairro" required />
                </div>

                <div class="form-group mb-30 col-12 col-md-3">
                  <label for="form-estado"><i class="fas fa-flag"></i></label>
                  <!-- <input
                    type="text"
                    id="form-estado"
                    placeholder="Estado"
                    v-model="endereco.estado"
                    required
                  /> -->

                  <select id="form-estado" v-model="endereco.estado" @change="searchMunicipios" required>
                    <option value="">Estado</option>
                    <option value="AC">AC</option>
                    <option value="AL">AL</option>
                    <option value="AP">AP</option>
                    <option value="AM">AM</option>
                    <option value="BA">BA</option>
                    <option value="CE">CE</option>
                    <option value="DF">DF</option>
                    <option value="ES">ES</option>
                    <option value="GO">GO</option>
                    <option value="MA">MA</option>
                    <option value="MT">MT</option>
                    <option value="MS">MS</option>
                    <option value="MG">MG</option>
                    <option value="PR">PR</option>
                    <option value="PB">PB</option>
                    <option value="PA">PA</option>
                    <option value="PE">PE</option>
                    <option value="PI">PI</option>
                    <option value="RJ">RJ</option>
                    <option value="RN">RN</option>
                    <option value="RS">RS</option>
                    <option value="RO">RO</option>
                    <option value="RR">RR</option>
                    <option value="SC">SC</option>
                    <option value="SE">SE</option>
                    <option value="SP">SP</option>
                    <option value="TO">TO</option>
                  </select>
                </div>

                <div class="form-group mb-30 col-12 col-md-5">
                  <label for="form-cidade"><i class="fas fa-city"></i></label>
                  <select v-model="endereco.cidade">
                    <option value="">Cidade</option>
                    <option v-if="getLoadingMunicipios" value="-1" selected>Carregando...</option>
                    <option v-for="c in getMunicipiosInfo" :key="c.id" :value="c.nome">{{ c.nome }}</option>
                  </select>
                </div>

                <div class="col-12" v-if="!identityId">
                  <p class="title"><i class="far fa-user-circle"></i> Conta</p>
                  <hr />
                </div>

                <span class="d-flex w-100 pl-3" style="font-size: 12px; text-align: left" for="ajuda">
                  Esse apelido aparecerá ao dar lance nos leilões.
                </span>
                <div class="form-group mb-20 col-12">
                  <label for="apelido"><i class="fas fa-user-tag"></i></label>
                  <input :class="verifyNomeUsuario" type="text" id="apelido" placeholder="Apelido" size="15"
                    minlength="5" maxlength="15" v-model="nomeUsuario" @input="debounceCheckNomeUsuario" required />
                </div>

                <div class="d-flex w-100 pl-3 flex-column">
                  <p v-if="getLoadingNomeUsuario">
                    <i class="fas fa-spinner fa-spin mr-1"></i>
                    Verificando...
                  </p>
                  <p v-if="nomeUsuario && getNomeUsuarioExists && !nomeUsuarioError && !getLoadingNomeUsuario"
                    class="text-danger">
                    <i class="fas fa-times-circle text-danger mr-1"></i>
                    Esse nome de usuário já existe, por favor escolha outro!
                  </p>
                  <p v-if="nomeUsuario && nomeUsuarioError && !getLoadingNomeUsuario" class="text-danger">
                    <i class="fas fa-times-circle text-danger mr-1"></i>
                    O nome de usuário contém caracteres especiais que não são permitidos. Use apenas letras e números e
                    os seguintes
                    caracteres: "-",
                    "." e "_".
                  </p>
                  <p v-if="nomeUsuario && !getNomeUsuarioExists && !nomeUsuarioError && !getLoadingNomeUsuario"
                    class="text-success">
                    <i class="fa fa-check-circle text-success mr-1"></i>
                    O nome de usuário está disponível.
                  </p>

                  <p v-if="nomeUsuario && getNomeUsuarioExists && !nomeUsuarioError && !getLoadingNomeUsuario && sugestoesNomeUsuario.length > 0"
                    class="title">
                    <strong>Sugestões: </strong>
                    <span v-for="(sugestao, index) in sugestoesNomeUsuario" :key="index">
                      <a href="javascript:void(0)" @click="selecionarSugestao(sugestao)" class="sugestao-link">{{
                        sugestao }}</a><span v-if="index < sugestoesNomeUsuario.length - 1">, </span>
                    </span>
                  </p>
                </div>

                <div class="form-group mb-30 col-12 is-invalid col-md-6" v-if="!identityId">
                  <label for="login-email"><i class="fas fa-envelope"></i></label>
                  <input type="email" id="login-email" placeholder="Email" v-model="email" required />
                </div>
                <div class="form-group mb-30 col-12 is-invalid col-md-6" v-if="!identityId">
                  <label for="login-email-conf"><i class="fas fa-envelope"></i></label>
                  <input type="email" id="login-email-conf" placeholder="Confirmação de Email" v-model="emailconf"
                    required />
                </div>
                <div class="form-group mb-30 col-12 col-md-6" v-if="!identityId">
                  <label for="login-pass"><i class="fas fa-lock"></i></label>
                  <input :type="passwordFieldType" id="login-pass" placeholder="Senha" v-model="senha" required />
                  <span class="pass-type" @click="switchVisibility()"><i class="fas"
                      :class="{ 'fa-eye': passwordFieldType == 'password', 'fa-eye-slash': passwordFieldType != 'password' }"></i></span>
                </div>
                <div class="form-group mb-30 col-12 col-md-6" v-if="!identityId">
                  <label for="login-pass-conf"><i class="fas fa-lock"></i></label>
                  <input :type="passwordFieldType2" id="login-pass-conf" placeholder="Confirmaçao de senha"
                    v-model="confsenha" required />
                  <span class="pass-type" @click="switchVisibility2()"><i class="fas"
                      :class="{ 'fa-eye': passwordFieldType2 == 'password', 'fa-eye-slash': passwordFieldType2 != 'password' }"></i></span>
                </div>
                <div class="form-group checkgroup mb-20 col-12">
                  <input type="checkbox" name="recebeWhatsApp" id="recebeWhatsApp" v-model="recebeWhatsApp" />
                  <label for="recebeWhatsApp">&nbsp; Quero receber notificações por WhatsApp (ex: lances, faturas,
                    habilitação)</label>
                </div>
                <div class="form-group checkgroup mb-30 col-12">
                  <input type="checkbox" name="terms" id="check" v-model="aceiteTermo" />
                  <label>&nbsp; Li e Aceito os termos de uso.
                    <!-- <a href="/termos-de-uso" target="_blank"
                      >Clique Aqui</a
                    > -->
                    <a :href="'/pagina/' + getTermoUso.rota" v-if="getTermoUso" target="_blank"> Clique Aqui </a>
                  </label>
                </div>
                <div class="mb-30 col-12">
                  <div class="alert alert-danger" v-for="error in getCadastroError" :key="error">
                    {{ error }}
                  </div>
                  <div class="alert alert-danger" v-if="error">
                    {{ error }}
                  </div>
                </div>
                <div class="form-group mb-0">
                  <button type="submit" class="custom-button login-button" :disabled="isCadastroEnable">
                    <i class="fa fa-spin fa-spinner" v-if="getCadastroLoading"></i>
                    CADASTRAR
                  </button>
                </div>
              </div>
              <div class="row justify-content-center" v-if="tipoPessoa == 'PJ'">
                <div class="col-12">
                  <p class="title"><i class="far fa-building"></i> Dados da Empresa</p>
                  <hr />
                </div>

                <div class="form-group mb-30 col-12">
                  <label for="razao-social"><i class="fas fa-building"></i></label>
                  <input type="text" id="razao-social" placeholder="Razão Social" v-model="razaoSocial" required />
                </div>

                <div class="form-group mb-30 col-12">
                  <label for="cnpj"><i class="fas fa-id-card"></i></label>
                  <input :class="verifyNumeroDocumento" type="text" id="cnpj" placeholder="CNPJ"
                    v-model="numeroDocumento" v-mask="'##.###.###/####-##'" required
                    @input="debounceCheckNumeroDocumento" />
                </div>

                <div class="d-flex w-100 pl-3">
                  <p v-if="getLoadingNumeroDocumento">
                    <i class="fas fa-spinner fa-spin mr-2"></i>
                    Verificando...
                  </p>
                  <p v-if="numeroDocumento && getNumeroDocumentoExists === true && !getLoadingNumeroDocumento"
                    class="text-danger">
                    <i class="fas fa-times-circle text-danger mr-1"></i>
                    O CNPJ está sendo utilizado por outro usuário.
                  </p>
                  <p v-if="numeroDocumento && getNumeroDocumentoExists === false && !getLoadingNumeroDocumento"
                    class="text-success">
                    <i class="fa fa-check-circle text-success mr-1"></i>
                    O CNPJ está disponível.
                  </p>
                </div>

                <div class="form-group mb-30 col-12 col-md-6">
                  <label for="telefone-pj"><i class="fas fa-phone-alt"></i></label>
                  <input type="text" id="telefone-pj" placeholder="Telefone (Empresa)" v-model="telefoneEmpresa"
                    v-mask="'(##) #####-####'" required />
                </div>
                <div class="form-group mb-30 col-12 col-md-6">
                  <label for="telefone-pj-conf"><i class="fas fa-phone-alt"></i></label>
                  <input type="text" id="telefone-pj-conf" placeholder="Confirmação de Telefone"
                    v-model="telefoneEmpresaConf" v-mask="'(##) #####-####'" required />
                </div>

                <div class="col-12">
                  <p class="title"><i class="fas fa-address-card"></i> Dados do Representante</p>
                  <hr />
                </div>
                <div class="form-group mb-30 col-12">
                  <label for="nome-completo"><i class="fas fa-user"></i></label>
                  <input type="text" id="nome-completo" placeholder="Nome completo" v-model="responsavel.nomeCompleto"
                    required />
                </div>

                <div class="form-group mb-30 col-12">
                  <label for="cpf"><i class="fas fa-id-card"></i></label>
                  <input type="text" id="cpf" placeholder="CPF" v-model="responsavel.numeroDocumento"
                    v-mask="'###.###.###-##'" required />
                </div>

                <div class="form-group mb-30 col-12 col-md-6">
                  <label for="data-nascimento"><i class="fas fa-calendar-alt"></i></label>
                  <input type="text" id="data-nascimento" placeholder="Data nascimento"
                    v-model="responsavel.dataNascimento" v-mask="'##/##/####'" required />
                </div>

                <div class="form-group mb-30 col-12 col-md-6">
                  <label for="genero"><i class="fas fa-venus-mars"></i></label>
                  <select id="genero" v-model="responsavel.genero" required>
                    <option value="">Gênero</option>
                    <option value="F">Feminino</option>
                    <option value="M">Masculino</option>
                    <option value="O">Outro</option>
                  </select>
                </div>

                <div class="form-group mb-30 col-12 col-md-6">
                  <label for="telefone"><i class="fas fa-phone-alt"></i></label>
                  <input type="text" id="telefone" placeholder="Celular" v-model="telefone" v-mask="'(##) #####-####'"
                    required />
                </div>
                <div class="form-group mb-30 col-12 col-md-6">
                  <label for="telefone-conf"><i class="fas fa-phone-alt"></i></label>
                  <input type="text" id="telefone-conf" placeholder="Confirmação de Celular" v-model="telefoneconf"
                    v-mask="'(##) #####-####'" required />
                </div>

                <div class="col-12">
                  <p class="title"><i class="fas fa-map-marker-alt"></i> Endereço da Empresa</p>
                  <hr />
                </div>
                <div class="form-group mb-30 col-12 col-md-4">
                  <label for="form-cep"><i class="fas fa-location-arrow"></i></label>
                  <input type="text" id="form-cep" placeholder="cep" v-model="endereco.cep" required
                    v-mask="'#####-###'" v-on:change="searchCep" />
                  <span class="pass-type" v-if="getLoadingCep"><i class="fa fa-spin fa-spinner"></i></span>
                </div>

                <div class="form-group mb-30 col-12 col-md-8">
                  <label for="form-logradouro"><i class="fas fa-road"></i></label>
                  <input type="text" id="form-logradouro" placeholder="Logradouro" v-model="endereco.logradouro"
                    required />
                </div>
                <div class="form-group mb-30 col-12 col-md-4">
                  <label for="form-numero"><i class="fas fa-map-pin"></i></label>
                  <input type="text" id="form-numero" placeholder="Número" v-model="endereco.numero" required />
                </div>

                <div class="form-group mb-30 col-12 col-md-8">
                  <label for="form-complemento"><i class="fas fa-map-signs"></i></label>
                  <input type="text" id="form-complemento" placeholder="Complemento" v-model="endereco.complemento" />
                </div>

                <div class="form-group mb-30 col-12 col-md-4">
                  <label for="form-bairro"><i class="fas fa-building"></i></label>
                  <input type="text" id="form-bairro" placeholder="Bairro" v-model="endereco.bairro" required />
                </div>

                <div class="form-group mb-30 col-12 col-md-3">
                  <label for="form-estado"><i class="fas fa-flag"></i></label>
                  <!-- <input
                    type="text"
                    id="form-estado"
                    placeholder="Estado"
                    v-model="endereco.estado"
                    required
                  /> -->

                  <select id="form-estado" v-model="endereco.estado" @change="searchMunicipios" required>
                    <option value="">Estado</option>
                    <option value="AC">AC</option>
                    <option value="AL">AL</option>
                    <option value="AP">AP</option>
                    <option value="AM">AM</option>
                    <option value="BA">BA</option>
                    <option value="CE">CE</option>
                    <option value="DF">DF</option>
                    <option value="ES">ES</option>
                    <option value="GO">GO</option>
                    <option value="MA">MA</option>
                    <option value="MT">MT</option>
                    <option value="MS">MS</option>
                    <option value="MG">MG</option>
                    <option value="PR">PR</option>
                    <option value="PB">PB</option>
                    <option value="PA">PA</option>
                    <option value="PE">PE</option>
                    <option value="PI">PI</option>
                    <option value="RJ">RJ</option>
                    <option value="RN">RN</option>
                    <option value="RS">RS</option>
                    <option value="RO">RO</option>
                    <option value="RR">RR</option>
                    <option value="SC">SC</option>
                    <option value="SE">SE</option>
                    <option value="SP">SP</option>
                    <option value="TO">TO</option>
                  </select>
                </div>

                <div class="form-group mb-30 col-12 col-md-5">
                  <label for="form-cidade"><i class="fas fa-city"></i></label>
                  <select v-model="endereco.cidade">
                    <option value="">Cidade</option>
                    <option v-if="getLoadingMunicipios" value="-1" selected>Carregando...</option>
                    <option v-for="c in getMunicipiosInfo" :key="c.id" :value="c.nome">{{ c.nome }}</option>
                  </select>
                </div>

                <div class="col-12" v-if="!identityId">
                  <p class="title"><i class="far fa-user-circle"></i> Conta</p>
                  <hr />
                </div>

                <span class="d-flex w-100 pl-3" style="font-size: 12px; text-align: left" for="ajuda">
                  Esse apelido aparecerá ao dar lance nos leilões.
                </span>
                <div class="form-group mb-20 col-12">
                  <label for="apelido"><i class="fas fa-user-tag"></i></label>
                  <input :class="verifyNomeUsuario" type="text" id="apelido" placeholder="Apelido" size="15"
                    minlength="5" maxlength="15" v-model="nomeUsuario" @input="debounceCheckNomeUsuario" required />
                </div>

                <div class="d-flex w-100 pl-3 flex-column">
                  <p v-if="getLoadingNomeUsuario">
                    <i class="fas fa-spinner fa-spin mr-1"></i>
                    Verificando...
                  </p>
                  <p v-if="nomeUsuario && getNomeUsuarioExists && !nomeUsuarioError && !getLoadingNomeUsuario"
                    class="text-danger">
                    <i class="fas fa-times-circle text-danger mr-1"></i>
                    Esse nome de usuário já existe, por favor escolha outro!
                  </p>
                  <p v-if="nomeUsuario && nomeUsuarioError && !getLoadingNomeUsuario" class="text-danger">
                    <i class="fas fa-times-circle text-danger mr-1"></i>
                    O nome de usuário contém caracteres especiais que não são permitidos. Use apenas letras e números e
                    os seguintes
                    caracteres: "-",
                    "." e "_".
                  </p>
                  <p v-if="nomeUsuario && !getNomeUsuarioExists && !nomeUsuarioError && !getLoadingNomeUsuario"
                    class="text-success">
                    <i class="fa fa-check-circle text-success mr-1"></i>
                    O nome de usuário está disponível.
                  </p>

                  <p v-if="nomeUsuario && getNomeUsuarioExists && !nomeUsuarioError && !getLoadingNomeUsuario && sugestoesNomeUsuario.length > 0"
                    class="title">
                    <strong>Sugestões:</strong>
                    <span v-for="(sugestao, index) in sugestoesNomeUsuario" :key="index">
                      <a href="javascript:void(0)" @click="selecionarSugestao(sugestao)" class="sugestao-link">{{
                        sugestao }}</a><span v-if="index < sugestoesNomeUsuario.length - 1">, </span>
                    </span>
                  </p>
                </div>

                <div class="form-group mb-30 col-12 is-invalid" v-if="!identityId">
                  <label for="login-email"><i class="fas fa-envelope"></i></label>
                  <input type="email" id="login-email" placeholder="Email" v-model="email" required />
                </div>

                <div class="form-group mb-30 col-12 is-invalid" v-if="!identityId">
                  <label for="login-email-conf"><i class="fas fa-envelope"></i></label>
                  <input type="email" id="login-email-conf" placeholder="Confirmação de Email" v-model="emailconf"
                    required />
                </div>

                <div class="form-group mb-30 col-12" v-if="!identityId">
                  <label for="login-pass"><i class="fas fa-lock"></i></label>
                  <input :type="passwordFieldType" id="login-pass" placeholder="Senha" v-model="senha" required />
                  <span class="pass-type" @click="switchVisibility()"><i class="fas"
                      :class="{ 'fa-eye': passwordFieldType == 'password', 'fa-eye-slash': passwordFieldType != 'password' }"></i>
                  </span>
                </div>
                <div class="form-group mb-30 col-12" v-if="!identityId">
                  <label for="login-pass-conf"><i class="fas fa-lock"></i></label>
                  <input :type="passwordFieldType2" id="login-pass-conf" placeholder="Confirmaçao de senha"
                    v-model="confsenha" required />
                  <span class="pass-type" @click="switchVisibility2()"><i class="fas"
                      :class="{ 'fa-eye': passwordFieldType2 == 'password', 'fa-eye-slash': passwordFieldType2 != 'password' }"></i></span>
                </div>
                <div class="form-group checkgroup mb-20 col-12">
                  <input type="checkbox" name="recebeWhatsApp" id="recebeWhatsApp2" v-model="recebeWhatsApp" />
                  <label for="recebeWhatsApp2">&nbsp; Quero receber notificações por WhatsApp (ex: lances, faturas,
                    habilitação)</label>
                </div>
                <div class="form-group checkgroup mb-30 col-12">
                  <input type="checkbox" name="terms" id="check" v-model="aceiteTermo" />
                  <label>&nbsp; Li e Aceito os termos de uso.
                    <a :href="'/pagina/' + getTermoUso.rota" v-if="getTermoUso" target="_blank"> Clique Aqui </a>
                  </label>
                </div>
                <div class="mb-30 col-12">
                  <div class="alert alert-danger" v-for="error in getCadastroError" :key="error">
                    {{ error }}
                  </div>
                  <div class="alert alert-danger" v-if="error">
                    {{ error }}
                  </div>
                </div>
                <div class="form-group mb-0">
                  <button type="submit" class="custom-button login-button" :disabled="isCadastroEnable">
                    <i class="fa fa-spin fa-spinner" v-if="getCadastroLoading"></i>
                    CADASTRAR
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div class="right-side cl-white">
            <div class="section-header mb-0">
              <h3 class="title mt-0">JÁ POSSUI UMA CONTA?</h3>
              <a href="/login" class="custom-button cadastre-button">Entrar</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { APP_URL } from '../../config/config';
import estados from '../../data/estados_brasil.json';
import moment from 'moment';
import notification from '@/mixins/notification';
moment.locale('pt-br');

export default {
  data() {
    return {
      identityId: '',
      email: '',
      emailconf: '',
      senha: '',
      confsenha: '',
      nomeCompleto: '',
      razaoSocial: '',
      nomeUsuario: '',
      nomeUsuarioError: null,
      sugestoesNomeUsuario: [],
      dataNascimento: '',
      dataAbertura: '',
      dataEmissor: '',
      orgaoEmissor: '',
      rg: '',
      genero: '',
      tipoPessoa: 'PF',
      numeroDocumento: '',
      cpf: '',
      telefone: '',
      telefoneconf: '',
      telefoneEmpresa: '',
      telefoneEmpresaConf: '',
      provedor: '',
      errors: [],
      estados: estados,
      responsavel: {
        nomeCompleto: this.nomeCompleto,
        dataNascimento: '',
        tipoPessoa: '',
        genero: '',
        numeroDocumento: this.cpf,
        telefoneCelular: '',
      },
      endereco: {
        cep: '',
        logradouro: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
      },
      debounce: null,
      aceiteTermo: false,
      recebeWhatsApp: true,
      error: '',
      colorPrimary: process.env.VUE_APP_PRIMARY_COLOR,
      colorSecondary: process.env.VUE_APP_SECONDARY_COLOR,
      colorConstrast: process.env.VUE_APP_CONSTRAST_COLOR,
      passwordFieldType: 'password',
      passwordFieldType2: 'password',
    };
  },
  mixins: [notification],
  watch: {
    dataNascimento() {
      if (this.nomeUsuario && this.getNomeUsuarioExists && !this.nomeUsuarioError && !this.getLoadingNomeUsuario) {
        this.sugestoesNomeUsuario = this.gerarSugestoesNomeUsuario(this.nomeUsuario);
      }
    },
    'responsavel.dataNascimento'() {
      if (this.tipoPessoa === 'PJ' && this.nomeUsuario && this.getNomeUsuarioExists && !this.nomeUsuarioError && !this.getLoadingNomeUsuario) {
        this.sugestoesNomeUsuario = this.gerarSugestoesNomeUsuario(this.nomeUsuario);
      }
    },
  },
  computed: {
    ...mapGetters([
      'getCadastroLoading',
      'getCadastroError',
      'getRegisterCompleted',
      'getAuth',
      'getLoadingCep',
      'getPaginas',
      'getLoadingMunicipios',
      'getMunicipiosInfo',
      'getLoadingNomeUsuario',
      'getNomeUsuarioExists',
      'getLoadingNumeroDocumento',
      'getNumeroDocumentoExists',
    ]),
    getTermoUso() {
      if (!this.getPaginas) return;
      return this.getPaginas.find((x) => x.rota == 'termos-de-uso');
    },
    verifyNomeUsuario() {
      return this.nomeUsuario && this.getNomeUsuarioExists && !this.getLoadingNomeUsuario
        ? 'border border-danger'
        : this.nomeUsuario && !this.getNomeUsuarioExists && !this.getLoadingNomeUsuario
          ? 'border border-success'
          : '';
    },
    verifyNumeroDocumento() {
      return this.numeroDocumento && this.getNumeroDocumentoExists === true && !this.getLoadingNumeroDocumento
        ? 'border border-danger'
        : this.numeroDocumento && this.getNumeroDocumentoExists === false && !this.getLoadingNumeroDocumento
          ? 'border border-success'
          : '';
    },
    isCadastroEnable() {
      return (
        this.getCadastroLoading ||
        this.getNomeUsuarioExists ||
        this.getNumeroDocumentoExists === true
      );
    }
  },
  methods: {
    ...mapMutations(['SET_NUMERO_DOCUMENTO_EXISTS', 'SET_NOME_USUARIO_EXISTS']),
    ...mapActions([
      'setCadastro',
      'loadCep',
      'loadMunicipios',
      'checkNomeUsuario',
      'checkNumeroDocumento',
    ]),
    switchVisibility() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
    },
    switchVisibility2() {
      this.passwordFieldType2 = this.passwordFieldType2 === 'password' ? 'text' : 'password';
    },
    async cadastro() {
      this.error = '';

      if (this.tipoPessoa === 'PF') {
        if (this.telefone.replace(/\D/g, '') !== this.telefoneconf.replace(/\D/g, '')) {
          this.error = 'Os campos Telefone e Confirmação estão diferentes';
          return false;
        }
      } else {
        if (this.telefoneEmpresa.replace(/\D/g, '') !== this.telefoneEmpresaConf.replace(/\D/g, '')) {
          this.error = 'Os campos Telefone da Empresa e Confirmação de Telefone estão diferentes.';
          return false;
        }
      }

      if (this.email.toLowerCase() !== this.emailconf.toLowerCase()) {
        this.error = 'Os campos Email e Confirmação de Email estão diferentes.';
        return false;
      }

      if (this.senha !== this.confsenha) {
        this.error = 'Os campos Senha e Confirmação de Senha estão diferentes.';
        return false;
      }

      if (this.dataNascimento.length === 10 && !moment(this.dataNascimento, 'DD/MM/YYYY').isValid()) {
        this.error = 'A Data de Nascimento está inválida.';
        return false;
      }

      // if (this.dataNascimento.length === 10 && !moment(this.dataEmissor, 'DD/MM/YYYY').isValid()) {
      //   this.error = 'A Data Emissão está inválida.';
      //   return false;
      // }

      if (!this.aceiteTermo) {
        this.error = 'Leia e aceite os termos de uso.';
        return false;
      }

      if (this.nomeUsuario === '' || this.nomeUsuario === null) {
        this.error = 'Nome de Usuário é obrigatório';
        return false;
      }

      if (this.nomeUsuario.length > 15) {
        this.error = 'Nome de Usuário não pode ter mais de 15 caracteres';
        return false;
      }

      if (this.getNomeUsuarioExists) {
        this.error = 'O nome de usuário já está em uso';
        return false;
      }

      if (this.nomeUsuarioError) {
        this.error = ' Só será possível cadastrar o apelido com os seguintes caracteres especiais: "." "-" e "_"';
        return false;
      }

      let payload = {};

      if (this.tipoPessoa === 'PF') {
        payload = {
          identityId: this.identityId,
          nomeCompleto: this.nomeCompleto,
          dataNascimento: this.dataNascimento && this.dataNascimento.split('/').reverse().join('-'),
          orgaoEmissor: this.orgaoEmissor,
          genero: this.genero,
          tipoPessoa: this.tipoPessoa,
          numeroDocumento: this.numeroDocumento,
          telefoneCelular: this.telefone,
          telefoneWhatsapp: this.telefone,
          rg: this.rg,
          nomeUsuario: this.nomeUsuario,
          email: this.email.toLowerCase(),
          senha: this.senha,
          endereco: this.endereco,
          returnUrl: APP_URL + 'login',
          recebeWhatsApp: this.recebeWhatsApp,
          emailConfirmado: true,
        };
      } else {
        payload = {
          indentityId: this.indentityId,
          nomeCompleto: this.razaoSocial,
          numeroDocumento: this.numeroDocumento,
          tipoPessoa: this.tipoPessoa,
          telefoneCelular: this.telefoneEmpresa,
          telefoneWhatsapp: this.telefoneEmpresa,
          responsavel: {
            ...this.responsavel,
            dataNascimento: moment(this.responsavel.dataNascimento, 'DD/MM/YYYY').toISOString(),
            tipoPessoa: 'PF',
            telefoneCelular: this.telefone,
          },
          nomeUsuario: this.nomeUsuario,
          email: this.email.toLowerCase(),
          senha: this.senha,
          endereco: this.endereco,
          returnUrl: APP_URL + 'login',
          recebeWhatsApp: this.recebeWhatsApp,
          emailConfirmado: true,
        };
      }

      try {
        await this.setCadastro(payload);
      } catch (_) {
        this.showAlert({
          type: 'error',
          title: 'ATENÇÃO',
          message: 'Houve um erro ao completar o cadastro',
        });

        if (window.innerWidth < 700) window.scrollTo(0, 2100);
      }
    },
    async searchCep(event) {
      if (event) {
        event.preventDefault();
      }

      if (this.endereco.cep.length === 9) {
        this.loadCep(this.endereco.cep)
          .then(async (resp) => {
            this.endereco.logradouro = resp.logradouro;
            this.endereco.bairro = resp.bairro;
            this.endereco.estado = resp.uf;
            await this.searchMunicipios();
            this.endereco.cidade = resp.localidade;
          })
          .catch(() => {
            this.endereco.logradouro = '';
            this.endereco.bairro = '';
            this.endereco.cidade = '';
            this.endereco.estado = '';
          });
      }
    },

    async searchMunicipios() {
      this.endereco.cidade = '-1';
      await this.loadMunicipios(this.endereco.estado);
      this.endereco.cidade = '';
    },

    debounceCheckNomeUsuario() {
      if (this.debounce) {
        clearTimeout(this.debounce);
      }
      this.debounce = setTimeout(this.checkNomeUsuarioExists, 300);
    },

    async checkNomeUsuarioExists() {
      this.error = '';
      if (this.nomeUsuario === '' || this.nomeUsuario === null || this.nomeUsuario === undefined) {
        this.error = 'Nome de Usuário é obrigatório';
        this.sugestoesNomeUsuario = [];
        return false;
      }
      if (this.nomeUsuario.length > 15) {
        this.error = 'Nome de Usuário não pode ter mais de 15 caracteres';
        this.sugestoesNomeUsuario = [];
        return false;
      }

      await this.checkNomeUsuario(this.nomeUsuario);

      const regex = /[!@#$%^&*()+{}\\[\]:;<>,?~´`çÇ\s]/gm;

      this.nomeUsuarioError = regex.test(this.nomeUsuario);

      if (this.getNomeUsuarioExists && !this.nomeUsuarioError) {
        this.sugestoesNomeUsuario = this.gerarSugestoesNomeUsuario(this.nomeUsuario);
      } else {
        this.sugestoesNomeUsuario = [];
      }
    },

    gerarSugestoesNomeUsuario(username) {
      const sugestoes = [];
      const nomeBase = username.toLowerCase().trim();

      if (nomeBase.length >= 15) {
        const sugestoesDoNome = this.gerarSugestoesDoNomeCompleto();
        return [...new Set(sugestoesDoNome)].slice(0, 5);
      }

      const sugestoesDoUsername = [];

      let dataNasc = null;
      if (this.tipoPessoa === 'PF') {
        dataNasc = this.dataNascimento;
      } else if (this.tipoPessoa === 'PJ') {
        dataNasc = this.responsavel.dataNascimento;
      }

      let anoNascimento = null;
      let ano2Digitos = null;
      if (dataNasc && dataNasc.length === 10) {
        const partes = dataNasc.split('/');
        if (partes.length === 3 && partes[2]) {
          anoNascimento = partes[2];
          ano2Digitos = anoNascimento.slice(-2);
        }
      }

      if (ano2Digitos && (nomeBase + ano2Digitos).length <= 15) {
        sugestoesDoUsername.push(nomeBase + ano2Digitos);
      }

      const numAleatorio = Math.floor(Math.random() * 90) + 10;
      if ((nomeBase + numAleatorio).length <= 15) {
        sugestoesDoUsername.push(nomeBase + numAleatorio);
      }

      const numAleatorio2 = Math.floor(Math.random() * 90) + 10;
      if ((nomeBase + '_' + numAleatorio2).length <= 15) {
        sugestoesDoUsername.push(nomeBase + '_' + numAleatorio2);
      }

      if (sugestoesDoUsername.length < 3 && ano2Digitos) {
        if ((nomeBase + '.' + ano2Digitos).length <= 15) {
          sugestoesDoUsername.push(nomeBase + '.' + ano2Digitos);
        }
        if (sugestoesDoUsername.length < 3 && (nomeBase + '-' + ano2Digitos).length <= 15) {
          sugestoesDoUsername.push(nomeBase + '-' + ano2Digitos);
        }
      }

      sugestoes.push(...sugestoesDoUsername.slice(0, 3));

      const sugestoesDoNome = this.gerarSugestoesDoNomeCompleto();
      sugestoes.push(...sugestoesDoNome.slice(0, 2));

      const sugestoesUnicas = [...new Set(sugestoes)].filter(s => s !== nomeBase);
      return sugestoesUnicas.slice(0, 5);
    },

    gerarSugestoesDoNomeCompleto() {
      const sugestoes = [];

      let nomeCompleto = '';
      if (this.tipoPessoa === 'PF') {
        nomeCompleto = this.nomeCompleto || '';
      } else if (this.tipoPessoa === 'PJ') {
        nomeCompleto = this.responsavel.nomeCompleto || '';
      }

      if (!nomeCompleto || nomeCompleto.trim() === '') {
        const numAleatorio = Math.floor(Math.random() * 90) + 10;
        const numAleatorio2 = Math.floor(Math.random() * 90) + 10;
        const numAleatorio3 = Math.floor(Math.random() * 900) + 100;

        return [
          `user${numAleatorio}`,
          `user${numAleatorio2}`,
          `user${numAleatorio3}`,
        ].slice(0, 3);
      }

      const partesNome = nomeCompleto.trim().toLowerCase().split(/\s+/).filter(p => p.length > 0);
      const primeiroNome = partesNome[0] || '';
      const ultimoNome = partesNome[partesNome.length - 1] || '';
      const segundoNome = partesNome.length > 2 ? partesNome[1] : '';
      const primeiroNome3 = primeiroNome.substring(0, 3);
      const primeiroNome4 = primeiroNome.substring(0, 4);
      const ultimoNome3 = ultimoNome.substring(0, 3);
      const ultimoNome4 = ultimoNome.substring(0, 4);

      let dataNasc = null;
      if (this.tipoPessoa === 'PF') {
        dataNasc = this.dataNascimento;
      } else if (this.tipoPessoa === 'PJ') {
        dataNasc = this.responsavel.dataNascimento;
      }

      let ano2Digitos = null;
      if (dataNasc && dataNasc.length === 10) {
        const partes = dataNasc.split('/');
        if (partes.length === 3 && partes[2]) {
          ano2Digitos = partes[2].slice(-2);
        }
      }

      if (primeiroNome && primeiroNome.length <= 15) {
        sugestoes.push(primeiroNome);
      }

      if (primeiroNome && ultimoNome && (primeiroNome + ultimoNome).length <= 15) {
        sugestoes.push(primeiroNome + ultimoNome);
      }

      if (primeiroNome && ano2Digitos && (primeiroNome + ano2Digitos).length <= 15) {
        sugestoes.push(primeiroNome + ano2Digitos);
      }

      if (primeiroNome) {
        const numAleatorio = Math.floor(Math.random() * 90) + 10;
        if ((primeiroNome + numAleatorio).length <= 15) {
          sugestoes.push(primeiroNome + numAleatorio);
        }
      }

      if (primeiroNome3 && ultimoNome && (primeiroNome3 + ultimoNome).length <= 15) {
        sugestoes.push(primeiroNome3 + ultimoNome);
      }

      if (primeiroNome && ultimoNome3 && (primeiroNome + '_' + ultimoNome3).length <= 15) {
        sugestoes.push(primeiroNome + '_' + ultimoNome3);
      }

      if (primeiroNome && ultimoNome3 && (primeiroNome + '.' + ultimoNome3).length <= 15) {
        sugestoes.push(primeiroNome + '.' + ultimoNome3);
      }

      if (primeiroNome && ultimoNome3 && (primeiroNome + '-' + ultimoNome3).length <= 15) {
        sugestoes.push(primeiroNome + '-' + ultimoNome3);
      }

      if (primeiroNome4 && ultimoNome && (primeiroNome4 + ultimoNome).length <= 15) {
        sugestoes.push(primeiroNome4 + ultimoNome);
      }

      if (primeiroNome && ultimoNome4 && (primeiroNome + ultimoNome4).length <= 15) {
        sugestoes.push(primeiroNome + ultimoNome4);
      }

      if (primeiroNome && segundoNome && (primeiroNome + segundoNome).length <= 15) {
        sugestoes.push(primeiroNome + segundoNome);
      }

      if (primeiroNome3 && segundoNome && (primeiroNome3 + segundoNome).length <= 15) {
        sugestoes.push(primeiroNome3 + segundoNome);
      }

      if (primeiroNome && ano2Digitos && (primeiroNome + '_' + ano2Digitos).length <= 15) {
        sugestoes.push(primeiroNome + '_' + ano2Digitos);
      }

      if (primeiroNome && ano2Digitos && (primeiroNome + '-' + ano2Digitos).length <= 15) {
        sugestoes.push(primeiroNome + '-' + ano2Digitos);
      }

      return [...new Set(sugestoes)].slice(0, 5);
    },

    selecionarSugestao(sugestao) {
      this.sugestoesNomeUsuario = [];
      this.SET_NOME_USUARIO_EXISTS(null);
      this.nomeUsuario = sugestao;
      this.$nextTick(() => {
        this.debounceCheckNomeUsuario();
      });
    },

    debounceCheckNumeroDocumento() {
      if (this.debounce) {
        clearTimeout(this.debounce);
      }
      this.debounce = setTimeout(this.checkNumeroDocumentoExists, 300);
    },

    async checkNumeroDocumentoExists() {
      if (this.tipoPessoa === 'PF' && this.numeroDocumento.length !== 14) {
        this.SET_NUMERO_DOCUMENTO_EXISTS(null);
        return;
      }
      if (this.tipoPessoa === 'PJ' && this.numeroDocumento.length !== 18) {
        this.SET_NUMERO_DOCUMENTO_EXISTS(null);
        return;
      }
      await this.checkNumeroDocumento(this.numeroDocumento);
    },
  },
  mounted() {
    this.email = this.getAuth && this.getAuth?.profile ? this.getAuth?.profile?.email : this.getAuth?.email;
    this.emailconf = this.getAuth && this.getAuth?.profile ? this.getAuth?.profile?.email : this.getAuth?.email;
    this.nomeCompleto = this.getAuth && this.getAuth?.profile ? this.getAuth?.profile?.full_name : this.getAuth?.full_name;
    this.identityId = this.getAuth && this.getAuth?.profile ? this.getAuth?.profile?.uid : this.getAuth?.uid;
  },
};
</script>

<style scoped>
.account-wrapper .right-side,
.login-button {
  background-color: v-bind(colorPrimary) !important;
  color: v-bind(colorConstrast) !important;
  font-weight: 500 !important;
}

.cadastre-button {
  background-color: v-bind(colorConstrast);
  color: v-bind(colorPrimary);
}

.login-form .form-group input,
select {
  padding-left: 40px;
}

.red {
  color: rgb(146, 0, 0);
  font-size: 18px;
}

.sugestao-link {
  color: inherit;
  text-decoration: none;
  cursor: pointer;
}

.sugestao-link:hover {
  text-decoration: underline;
}

@media (max-width: 576px) {
  .account-section {
    padding-top: 180px;
  }
}

.mb-10 {
  margin-bottom: 10px;
}

.gap-10 {
  gap: 10px;
}

.btn.btn-link.disabled {
  color: #868e96;
  cursor: not-allowed;
  text-decoration: none;
}
</style>
